import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useNavbarContext } from '../../../contexts/NavbarProvider';
import { SubRoutes } from '../../../types/common';
import { rootPath } from '../../../utils/commonFunctions';

const SubNavLinkButton = ({
  subRoute,
  routeTitle,
  pathname,
}: {
  subRoute: SubRoutes;
  routeTitle: string;
  pathname: string;
}) => {
  // integration of context hooks here
  const { showNavbar, isMobile } = useNavbarContext();

  // rendering nav link button component here
  return (
    <div
      title={!showNavbar ? `${subRoute.title} ${routeTitle}` : ''}
      className='relative'
    >
      <Link
        to={subRoute.href}
        className={`relative w-full block pr-2 py-4 text-xl duration-300 after:h-full after:w-0 after:absolute after:left-0 after:top-0 after:origin-left after:duration-300 whitespace-nowrap z-[5] border-l-2 border-legal-brown ${
          showNavbar ? 'ml-9 pl-4' : 'ml-7 pl-2'
        } ${
          rootPath(pathname) === subRoute.matcher
            ? 'text-legal-dark-blue hover:opacity-70'
            : 'hover:after:w-full after:bg-legal-dark-gray hover:text-base-white text-legal-brown'
        }`}
      >
        <span className='relative flex items-center gap-3 z-10'>
          <span>{subRoute.icon}</span>
          <motion.p
            initial={showNavbar ? { x: 0 } : isMobile ? { x: 0 } : { x: -260 }}
            animate={showNavbar ? { x: 0 } : isMobile ? { x: 0 } : { x: -260 }}
          >
            {subRoute.title}
          </motion.p>
        </span>

        <div className='absolute left-0 top-1/2 -translate-y-1/2 -translate-x-[calc(50%_+_1px)] size-[10px] rounded-full border-2 border-legal-brown bg-legal-dark-blue z-10'></div>

        <motion.div
          initial={{ width: 0 }}
          animate={
            rootPath(pathname) === subRoute.matcher
              ? { width: '100%' }
              : { width: 0 }
          }
          className='absolute left-0 top-0 h-full bg-legal-brown'
        ></motion.div>
      </Link>
    </div>
  );
};

export default SubNavLinkButton;
